import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { Servers } from '../../utils/api/servers'
import { axiosFetcher, type AxiosFetcherKey } from '../../utils/api/axios-fetcher'
import { type HeartbeatSimplified } from '../../models/heartbeat'

export function useHeartbeats (isAuthorized: boolean, accessToken: string | null): HeartbeatSimplified[] {
  const [heartbeats, setHeartbeats] = useState<HeartbeatSimplified[]>([])

  const { data, error } = useSWR<HeartbeatSimplified[], boolean, AxiosFetcherKey>(
    isAuthorized ? [Servers.STRATEGY_GATEWAY, null, 'ops-monitoring/heartbeat', accessToken, { simplified: true }] : null,
    axiosFetcher,
    {
      refreshInterval: 5000,
    }
  )

  useEffect(() => {
    if (data == null || (error === true)) {
      setHeartbeats([])
    } else {
      setHeartbeats(data)
    }
  }, [data, error])

  return heartbeats
}

export function useHeartbeatsImmutable (isAuthorized: boolean, accessToken: string | null): HeartbeatSimplified[] {
  const { data, error } = useSWR<HeartbeatSimplified[], boolean, AxiosFetcherKey>(
    isAuthorized ? [Servers.STRATEGY_GATEWAY, null, 'ops-monitoring/heartbeat', accessToken, { simplified: true }] : null,
    axiosFetcher
  )

  return (data == null || (error === true)) ? [] : data
}
